export default __webpack_public_path__ + "static/media/Default.b56f05eb.svg";